import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/ceshihome.vue'),
            hidden: true,
            redirect: 'Home',
            meta: {title: '网站首页'},
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./views/Home.vue'),
                    meta: {title: '主页'},
                }, {
                    path: 'course',
                    name: 'course',
                    component: () => import('./views/course'),
                    meta: {title: '课程'},
                }, {
                    path: 'math',
                    name: 'math',
                    component: () => import('./views/math/index.vue'),
                    meta: {title: '数学类'},
                },{
                    path: 'civilEngineering',
                    name: 'civilEngineering',
                    component: () => import('./views/civilEngineering/index.vue'),
                    meta: {title: '土木类'},
                },{
                    path: 'documentArea',
                    name: 'documentArea',
                    component: () => import('./views/documentArea/index.vue'),
                    meta: {title: '文档区'},
                },
                {
                    path: 'individualCenter',
                    name: 'individualCenter',
                    component: () => import('./App.vue'),
                    meta: {title: '个人中心'},
                    redirect: '/individualCenter/personalInformation', // 默认进入
                    children: [
                        {
                            path: 'personalInformation',
                            name: 'personalInformation',
                            component: () => import('./views/individualCenter/personalInformation/index.vue'),
                            meta: {title: '个人信息'},
                        }, {
                            path: 'myRelease',
                            name: 'myRelease',
                            component: () => import('./views/individualCenter/myRelease/index.vue'),
                            meta: {title: '我发布的'},
                        }, {
                            path: 'changePassword',
                            name: 'changePassword',
                            component: () => import('./views/individualCenter/changePassword/index.vue'),
                            meta: {title: '更改密码'},
                        }, {
                            path: 'logOut',
                            name: 'logOut',
                            component: () => import('./views/individualCenter/changePassword/index.vue'),
                            meta: {title: '退出登录'},
                        },
                    ]
                }, {
                    path: 'signIn',
                    name: 'signIn',
                    component: () => import('./views/individualCenter/signIn/index.vue'),
                    meta: {title: '注册'},
                }, {
                    path: 'login',
                    name: 'login',
                    component: () => import('./views/individualCenter/Login/Login.vue'),
                    meta: {title: '登录'},
                }, {
                    path: 'retrievePassword',
                    name: 'retrievePassword',
                    component: () => import('./views/individualCenter/retrievePassword/retrievePassword.vue'),
                    meta: {title: '找回密码'},
                },
            ]
        },
    ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
    // 判断是否需要登录权限
    if (to.matched.some(res => res.meta.requireAuth)) {
        // 判断是否登录
        if (sessionStorage.getItem('token')) {
            next()
        } else {
            // 没登录则跳转到登录界面
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next()
    }
})

export default kejianrouter
